import { ContentDataSchema } from "../../../apis/stateful-content";

export interface DownloadItem extends Record<string, any> {
    equipmentNumber?: string;
    name: string;
    id: number;
    typeId: number;
    languages: string[];
    date: string;
    path: string;
    size: number;
    category: number | string;
}

export interface DownloadGroup {
    label?: string;
    category: number | string;
    items: DownloadItem[];
}

export interface DownloadSchema extends ContentDataSchema {
    category: {
        order: Array<number | string>;
    };
}
